import { BaseDialogStoreState, IBaseDialogStoreState } from './baseDialogStoreState';

export interface IPublishConfirmationDialogStoreState extends IBaseDialogStoreState {
    title: string;
    msg: string;
    yesCallback: () => void;
    noCallback: () => void;
    yesBtnTxt?: string;
    noBtnTxt?: string;
    showExitBtn?: boolean;
}

export class PublishConfirmationDialogStoreState extends BaseDialogStoreState implements IPublishConfirmationDialogStoreState {
    title: string;
    msg: string;
    yesCallback: () => void;
    noCallback: () => void;
    yesBtnTxt?: string;
    noBtnTxt?: string;
    showExitBtn?: boolean;
    constructor() {
        super();
        this.title = '';
        this.msg = '';
    }
}
